import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import UserService from '@/services/UserService';

export const setPermissionsAsync = createAsyncThunk(
  'auth/permissionsAsync',
  async () => {
    const data = await UserService.getPermissions();
    return data;
  }
);

export const setCompanyConfigAsync = createAsyncThunk(
  'auth/companyConfigAsync',
  async () => {
    const data = await UserService.getCompanyConfig();
    return data;
  }
);

// Initial state
const initialState = {
  permissions: { waffle_flags: [] },
  companyConfig: {
    pdf_always_ask_agent_info: false,
    export_pdf_in_english: false,
    has_asiprop: null,
    has_uniloc: false,
  },
};

// Actual Slice
export const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setPermissionsState(state, action) {
      state.permissions = action.payload;
    },
    setCompanyConfig(state, action) {
      state.companyConfig = action.payload;
    },
    // Merges settings saved from other screens (e.g. the PDF configuration)
    // so the rest of the app sees them without a reload.
    mergeCompanyConfig(state, action) {
      Object.assign(state.companyConfig, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setPermissionsAsync.fulfilled, (state, action) => {
      const allPermissions = Object.values(action.payload.user_perms).flat();

      if (action.payload?.is_company_admin) {
        allPermissions.push('is_company_admin');
      }
      if (action.payload?.is_reservation_manager) {
        allPermissions.push('is_reservation_manager');
      }

      state.permissions = { ...action.payload, allPermissions };
    });

    builder.addCase(setCompanyConfigAsync.fulfilled, (state, action) => {
      state.companyConfig = action.payload;
    });
  },
});

export const { setPermissionsState, setCompanyConfig, mergeCompanyConfig } =
  AuthSlice.actions;

export const selectPermissionsState = (state) => state.AuthSlice.permissions;

export default AuthSlice.reducer;
